import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/axios';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [verifying, setVerifying] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setVerifying(false);
      return;
    }
    api.get(`/api/auth/verify-reset-token/${encodeURIComponent(token)}`)
      .then((res) => {
        setTokenValid(res.data.valid);
        setUsername(res.data.username || '');
      })
      .catch(() => {
        setTokenValid(false);
      })
      .finally(() => setVerifying(false));
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/api/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
    } finally {
      setSubmitting(false);
    }
  };

  if (verifying) {
    return (
      <Container className="py-5 d-flex justify-content-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container className="py-5" style={{ maxWidth: '440px' }}>
      <Card className="p-4">
        <h2 className="mb-4 text-center">Set New Password</h2>

        {!token || !tokenValid ? (
          <Alert variant="danger">
            This password reset link is invalid or has expired. Contact an administrator to request a new link.
          </Alert>
        ) : done ? (
          <Alert variant="success">
            Your password has been set successfully. <Link to="/login">Log in now</Link>
          </Alert>
        ) : (
          <>
            {username && (
              <p className="text-muted mb-3">
                Setting password for: <strong>{username}</strong>
              </p>
            )}
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoFocus
                  minLength={6}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  minLength={6}
                />
              </Form.Group>
              <Button type="submit" variant="primary" className="w-100" disabled={submitting}>
                {submitting ? 'Setting Password...' : 'Set Password'}
              </Button>
            </Form>
          </>
        )}

        <div className="text-center mt-3">
          <Link to="/login">Back to Login</Link>
        </div>
      </Card>
    </Container>
  );
};

export default ResetPassword;
